/**
 * Get the ng-checkout transaction id, or 'unavailable' when the browser blocks localStorage access.
 */
function getOrderId() {
  try {
    return window.localStorage.getItem('transaction_id') || null;
  } catch {
    return 'unavailable';
  }
}

/**
 * Common Sentry configuration for WP pages and ng-checkout.
 */
export const commonSentryConfig = {
  environment: process.env.SENTRY_ENVIRONMENT,
  dsn: 'https://7305355d9f91ab55e5526429bbecb3f5@o510915.ingest.us.sentry.io/4512203870896128',
  release: process.env.SENTRY_RELEASE,
  sampleRate: parseFloat(process.env.SENTRY_SAMPLE_RATE),
  denyUrls: [
    /^(chrome|moz|safari(-web)?)-extension:\/\//i,
    /^webkit-masked-url:/i,
    /^iabjs:\/\//i,
    /^file:\/\//i,
    /^https:\/\/static\.cloudflareinsights\.com\//i,
  ],
  beforeSend(event) {
    event.tags = {
      ...event.tags,
      order_id: getOrderId(),
    };

    return event;
  },
};
